import React from "react";
import PropTypes from "prop-types";

export default class PerPageSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange(e) {
    const { handleUpdate } = this.props;
    handleUpdate({ "perPage": e.target.value });
  }

  render() {
    const { perPageLabelBefore, perPageLabelAfter, perPage, perPageOptions } = this.props;
    
    return (
      <div className="search__per-page">
        { perPageLabelBefore ? perPageLabelBefore : "Show" }{ ": " }
        <select className="search__per-page__selector" onChange={(e)=>this.handleChange(e)} value={perPage}>
          {perPageOptions.map((option, i)=> (<option key={ i } value={option}>{ option }</option>))}
        </select>
        { perPageLabelAfter ? perPageLabelAfter : "results" }
      </div>
    );
  }
}

const { array, func, string, oneOfType, number } = PropTypes;

PerPageSelector.defaultProps = {
  perPage: '50'
}

PerPageSelector.propTypes= {
  handleUpdate: func,
  perPage: oneOfType([string, number,]),
  perPageOptions: array,
  perPageLabelBefore: string,
  perPageLabelAfter: string,
};
